import { color, Common } from '@stockbit/ui';
import Link from 'next/link';
import { useMemo, useState } from 'react';
import { parseEmoji } from 'utils/stream';
import {
  CloseReplyNestedContent,
  ReplyNestedContent,
  ReplyTextWrapper,
} from '../styled';
import ImageContainer from './ImageContainer';

const { Text, Iconmoon } = Common;

const MAX_CHARACTER = 100;

interface NestedReplyBoxProps {
  content: string;
  username: string;
  closable?: boolean;
  onClose?: () => any;
  images?: Array<string>;
}

function NestedReplyBox({
  content = '',
  username = '',
  closable = false,
  onClose = () => {},
  images = [],
}: NestedReplyBoxProps) {
  const [expanded, setExpanded] = useState(false);
  const showReadMore = content.length >= MAX_CHARACTER;
  const hasImage = images.length > 0 && images[0] !== '';

  const showContent = useMemo(() => {
    if (showReadMore && !expanded) {
      return `${content.substring(0, MAX_CHARACTER)}...`;
    }
    return content;
  }, [content, expanded, showReadMore]);

  return (
    <ReplyNestedContent>
      {closable && (
        <CloseReplyNestedContent onClick={onClose}>
          <Iconmoon className="icon-compose_close" size="14px" />
        </CloseReplyNestedContent>
      )}
      <Text color={color.gainsboro}>
        Replying to{' '}
        <Link href={`/${username}`}>
          <Text as="a" color={color.primary}>
            @{username}
          </Text>
        </Link>
      </Text>
      {hasImage && (
        <ImageContainer
          src={images[0]}
          style={{ height: '100px' }}
          imageStyle={{ position: 'absolute' }}
        />
      )}
      <ReplyTextWrapper expanded={expanded}>
        <Text m="10px 0">{parseEmoji(showContent)}</Text>
      </ReplyTextWrapper>
      {showReadMore && !expanded && (
        <Text
          color={color.primary}
          style={{ cursor: 'pointer' }}
          onClick={() => setExpanded(true)}
        >
          Read more...
        </Text>
      )}
    </ReplyNestedContent>
  );
}

export default NestedReplyBox;
